import React from 'react';
import { View } from 'react-native';

import { ncFileStatuses } from '@helpers';
import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import FeatureFlags from '@components/featureFlags';
import { NCFileIconProps } from '@v2/pages/machines/common/types/event';

export default ({ C, ncFileStatus }: NCFileIconProps) => {
  const renderIcon = () => {
    switch (ncFileStatus) {
      case ncFileStatuses.Unknown: {
        return (
          <FeatureFlags {...{ name: 'ncfile-update-nc-file-type' }}>
            <View
              style={{
                width: scale(12),
                height: scale(12),
                borderRadius: scale(12) / 2,
                backgroundColor: C('Status/Light/Missing'),
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
              }}
            >
              <Svg icon="exclamationMark" color={'Label/Light/AlwaysDark Primary'} width={scale(2)} height={scale(7)} />
            </View>
          </FeatureFlags>
        );
      }
      case ncFileStatuses.Linked: {
        return <Svg icon="ncFileActive" color={'Status/Light/Productive'} width={scale(12)} height={scale(12)} />;
      }
      case ncFileStatuses.Change: {
        return <Svg icon="ncFileChange" color={'Status/Light/Change'} width={scale(12)} height={scale(12)} />;
      }
      case ncFileStatuses.Ignored: {
        return <Svg icon="ncFileNotProductive" color={'Status/Light/Not Productive'} width={scale(12)} height={scale(12)} />;
      }
      case ncFileStatuses.Setup: {
        return <Svg icon="setup" color={'Status/Light/Setup'} width={scale(12)} height={scale(12)} />;
      }
      default:
        return null;
    }
  };
  return <View style={{ marginRight: scale(5) }}>{renderIcon()}</View>;
};
